exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, "/* ANIMATION */\n/* SHADOWS */\n.CoinInput__label__2TZCc.CoinInput__label__2TZCc.CoinInput__label__2TZCc {\n  margin-bottom: 15px;\n  font-size: 12px;\n  text-transform: uppercase;\n  color: #9c9c9c; }\n  @media (min-width: 992px) {\n    .CoinInput__label__2TZCc.CoinInput__label__2TZCc.CoinInput__label__2TZCc {\n      margin-bottom: 36px; } }\n\n.CoinInput__input__1U2Qe.CoinInput__input__1U2Qe.CoinInput__input__1U2Qe {\n  padding: 0 0 15px 120px;\n  font-size: 18px;\n  font-weight: 400;\n  margin-bottom: 0; }\n", ""]);

// exports
exports.locals = {
	"label": "CoinInput__label__2TZCc",
	"input": "CoinInput__input__1U2Qe"
};